module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_pt_portuguese-5681b94c0f2ec6559357587ba22b729f.svg";